<template lang="html">
  <section class="import_export_pack">
    <!-- Inizio Modal export -->
    <b-modal id="modal-export" title="Export"  size="lg" header-bg-variant="primary" header-text-variant="light" centered @show="initializeExport">
      <b-container fluid>
        <b-row class="mb-3">
          <div class="col-lg-2 mt-2">Export type:</div>
          <div class="col-lg-4">
            <b-form-select v-model="filter.exportType" :options="exportTypeList" :disabled="model == null"></b-form-select>
          </div>
          <div v-if="filter.exportType === 'Commercial'" class="col-lg-2 mt-2">Export model:</div>
          <div v-if="filter.exportType === 'Commercial'" class="col-lg-4">
            <b-form-select v-model="filter.exportModel" :options="exportModelList"></b-form-select>
          </div>
        </b-row>
        <b-row class="mb-3">
          <div v-if="filter.exportModel != 'Marketing (template)'" class="col-lg-2 mt-2">Destination:</div>
          <div v-if="filter.exportModel != 'Marketing (template)'" class="col-lg-4">
            <b-form-select v-model="filter.destination">
              <option value="final">Final</option>
              <option value="preview">Preview</option>
            </b-form-select>
          </div>
          <div v-if="filter.exportType === 'Commercial' && (filter.exportModel === 'Structural' || filter.exportModel === 'Marketing')" class="col-lg-2 mt-2">Filter by model:</div>
          <div v-if="filter.exportType === 'Commercial' && (filter.exportModel === 'Structural' || filter.exportModel === 'Marketing')" class="col-lg-4">
            <b-form-select v-model="filter.model" :options="filterModelList"></b-form-select>
          </div>
        </b-row>
        <b-row class="mb-3" v-if="filter.exportType === 'Commercial' && (filter.exportModel === 'Structural' || filter.exportModel === 'Marketing')">
          <div class='col-lg-2 mt-2'>Email Address:</div>
          <div class="col-lg-4">
            <input type='text' v-model="filter.email" class="col-lg-12"/>
          </div>
          <div class="col-lg-6">
            <b-alert variant="warning" :show="!isValidEmail" class="m-0">
              <i class="mdi mdi-alert-octagon"></i> Insert email address to receive export
            </b-alert>
          </div>
        </b-row>
      </b-container>
      <template v-slot:modal-footer="{ cancel, ok }" lang="html">
        <fragment>
          <b-button variant="secondary" @click="cancel()">Annulla</b-button>
          <b-button variant="primary" 
            :disabled="filter.exportType === 'Commercial' && (filter.exportModel === 'Structural' || filter.exportModel === 'Marketing') && !isValidEmail" 
            @click="filter.exportType === 'Implicit' ? exportImplicitPack() : (filter.exportModel === 'Marketing (template)' ? exportMarketingTemplate() : (filter.exportModel === 'Marketing' ? exportMarketing() : exportStructuralPack()))">
            Export
          </b-button>
        </fragment>
      </template>
    </b-modal>
    <!-- Fine Modal export -->
    <!-- Inizio Modal import -->
    <b-modal id="modal-import" title="Upload File"  size="lg" header-bg-variant="primary" header-text-variant="light" centered @show="initializeUpload">
        <b-container fluid v-if="!imported && !importedImplicit">
          <b-row class="mb-3">
            <div class="col-lg-2 mt-2">Import type:</div>
            <div class="col-lg-4">
              <b-form-select v-model="filter.exportType" :options="exportTypeList" :disabled="model == null || uploadImportCommlistResultView != null || uploadImportImplicitlistResultView != null"></b-form-select>
            </div>
            <div class="col-lg-2 mt-2">Destination:</div>
            <div class="col-lg-4">
              <b-form-select v-model="filter.destination">
                <option value="final">Final</option>
                <option value="preview">Preview</option>
              </b-form-select>
            </div>
          </b-row>
        </b-container>
        <div class='modal-body' v-if="filter.exportType === 'Commercial'">
          <b-row class="mb-3" v-if="!imported" >
            <div class="col-lg-2 mt-2">File:</div>
            <!-- Form -->
            <form method='post' action='' enctype='multipart/form-data' class="col-lg-4">
              <div class='custom-file mb-3'>
                <input type='file' class='custom-file-input' id='file-input' name='filename' @change="changeFileName()" :disabled="uploadImportCommlistResultView" :key="uploadImportCommlistResultView != null">
                <label class='custom-file-label' for='file-input'>{{fileName}}</label>
              </div>
              <br>
            </form>
          </b-row>
          <h2 v-if="imported">Import executed</h2>
          <template v-if='uploadImportCommlistResultView && uploadImportCommlistResultView.uploadErrorMsgList && uploadImportCommlistResultView.uploadErrorMsgList.length > 0'>
            <span style="color:red;">ATTENTION: problems occurred during loading the following items:</span><br/><br/>
            <span style="color:red;" :key = 'errorMsg' v-for="errorMsg in uploadImportCommlistResultView.uploadErrorMsgList">
              {{errorMsg}}<br/>
            </span>
          </template>
          <div v-if="!imported && uploadImportCommlistResultView">
            <b-table
              id="uploadEquipmentPreview"
              striped
              border
              hover
              responsive
              sticky-header="500px"
              small
              :items="uploadImportCommlistResultView ? uploadImportCommlistResultView.uploadedList : []"
              :fields="uploadCommPreviewFields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              primary-key="_id"
              no-local-sorting
              no-provider-paging
              sort-icon-left
              class="mt-3"
            >
            <!-- Custom row above header -->
              <template v-slot:thead-top="data" lang="html">
                <b-tr>
                  <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Import</b-th>
                </b-tr>
              </template>
              <!--  rows  -->
              <template v-slot:cell(isChecked)="data" lang="html"> 
                <input v-if="data.item.status == 0 && data.item.isHeader" type="checkbox" v-model="data.item.isChecked" @change="editUploadedItem(data.item)"/>
                <i v-if="data.item.status == 0 && !data.item.isHeader" class="mdi mdi-check" style="display: block; color:green;"><!-- --></i>                
                <i v-if="data.item.status != 0 && !data.item.isHeader" class="mdi mdi-window-close" style="display: block; color:red;"><!-- --></i>                
              </template>
              <template v-slot:cell(model)="data" lang="html">
                <b><span>{{data.item.vetList[0]}}</span></b>           
              </template>
              <template v-slot:cell(parentCode)="data" lang="html">
                <b><span>{{data.item.parentCode}}</span></b>           
              </template>
              <template v-slot:cell(ver)="data" lang="html">
                <b><span>{{data.item.ver}}</span></b>           
              </template>
              <template v-slot:cell(country)="data" lang="html">
                <b><span>{{data.item.country}}</span></b>           
              </template>
              <template v-slot:cell(compulsory)="data" lang="html">
                <span v-if="data.item.isHeader"><b>{{data.item.compulsory}}</b></span>
                <span v-if="!data.item.isHeader">{{data.item.compulsory}}</span>  
              </template>
              <template v-slot:cell(childCode)="data" lang="html">
                <span v-if="data.item.isHeader"><b>{{data.item.childCode}}</b></span>
                <span v-if="!data.item.isHeader">{{data.item.childCode}}</span>  
              </template>
              <template v-slot:cell(status)="data"  lang="html">
                <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
              </template>
            </b-table>
          </div>
          <!-- RESULT TABLES -->
          <div v-if="imported && uploadImportCommlistResultView && uploadImportCommlistResultView.importedList && uploadImportCommlistResultView.importedList.length > 0">
            <b-table
            id="importedCommPack"
            striped
            border
            hover
            responsive
            sticky-header="500px"
            small
            :items="uploadImportCommlistResultView ? uploadImportCommlistResultView.importedList : []"
            :fields="uploadCommPreviewFields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            primary-key="_id"
            no-local-sorting
            no-provider-paging
            sort-icon-left
            class="mt-3"
          >
          <!-- Custom row above header -->
            <template v-slot:thead-top="data" lang="html">
              <b-tr>
                <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Imported</b-th>
              </b-tr>
            </template>
            <!--  rows  -->
            <template v-slot:cell(isChecked)="data" lang="html">
              <span><!-- --></span>                
            </template>
            <template v-slot:cell(model)="data" lang="html">
              <b><span>{{data.item.vetList[0]}}</span></b>           
            </template>
            <template v-slot:cell(parentCode)="data" lang="html">
              <b><span>{{data.item.parentCode}}</span></b>           
            </template>
            <template v-slot:cell(ver)="data" lang="html">
              <b><span>{{data.item.ver}}</span></b>           
            </template>
            <template v-slot:cell(country)="data" lang="html">
              <b><span>{{data.item.country}}</span></b>           
            </template>
            <template v-slot:cell(compulsory)="data" lang="html">
              <span v-if="data.item.isHeader"><b>{{data.item.compulsory}}</b></span>
              <span v-if="!data.item.isHeader">{{data.item.compulsory}}</span>  
            </template>
            <template v-slot:cell(childCode)="data" lang="html">
              <span v-if="data.item.isHeader"><b>{{data.item.childCode}}</b></span>
              <span v-if="!data.item.isHeader">{{data.item.childCode}}</span>  
            </template>
            <template v-slot:cell(status)="data"  lang="html">
              <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
            </template>
          </b-table>
          </div>
          <div v-if="imported && uploadImportCommlistResultView && uploadImportCommlistResultView.notImportedList && uploadImportCommlistResultView.notImportedList.length > 0">
            <b-table
            id="notImportedCommPack"
            striped
            border
            hover
            responsive
            sticky-header="500px"
            small
            :items="uploadImportCommlistResultView ? uploadImportCommlistResultView.notImportedList : []"
            :fields="uploadCommPreviewFields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            primary-key="_id"
            no-local-sorting
            no-provider-paging
            sort-icon-left
            class="mt-3"
          >
          <!-- Custom row above header -->
            <template v-slot:thead-top="data" lang="html">
              <b-tr>
                <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Not Imported</b-th>
              </b-tr>
            </template>
            <!--  rows  -->
            <template v-slot:cell(isChecked)="data" lang="html">
              <span><!-- --></span>
            </template>
            <template v-slot:cell(model)="data" lang="html">
              <b><span>{{data.item.vetList[0]}}</span></b>           
            </template>
            <template v-slot:cell(parentCode)="data" lang="html">
              <b><span>{{data.item.parentCode}}</span></b>           
            </template>
            <template v-slot:cell(ver)="data" lang="html">
              <b><span>{{data.item.ver}}</span></b>           
            </template>
            <template v-slot:cell(country)="data" lang="html">
              <b><span>{{data.item.country}}</span></b>           
            </template>
            <template v-slot:cell(compulsory)="data" lang="html">
              <span v-if="data.item.isHeader"><b>{{data.item.compulsory}}</b></span>
              <span v-if="!data.item.isHeader">{{data.item.compulsory}}</span>  
            </template>
            <template v-slot:cell(childCode)="data" lang="html">
              <span v-if="data.item.isHeader"><b>{{data.item.childCode}}</b></span>
              <span v-if="!data.item.isHeader">{{data.item.childCode}}</span>  
            </template>
            <template v-slot:cell(status)="data"  lang="html">
              <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
            </template>
          </b-table>
          </div>
        </div>
        <div class='modal-body' v-else>
          <b-row class="mb-3" v-if="!importedImplicit">
            <div class="col-lg-2 mt-2">File:</div>
            <!-- Form -->
            <form method='post' action='' enctype='multipart/form-data' class="col-lg-4">
              <div class='custom-file mb-3'>
                <input type='file' class='custom-file-input' id='file-input-implicit' name='filename' @change="changeFileNameImplicit()" :disabled="uploadImportImplicitlistResultView" :key="uploadImportImplicitlistResultView != null">
                <label class='custom-file-label' for='file-input-implicit'>{{fileName}}</label>
              </div>
              <br>
            </form>
          </b-row>
          <!-- Preview-->
          <!-- <div id='preview'></div> -->
          <h2 v-if="importedImplicit">Import executed</h2>
          <template v-if='uploadImportImplicitlistResultView && uploadImportImplicitlistResultView.uploadErrorMsgList && uploadImportImplicitlistResultView.uploadErrorMsgList.length > 0'>
            <span style="color:red;">ATTENTION: problems occurred during loading the following items:</span><br/><br/>
            <span style="color:red;" :key = 'errorMsg' v-for="errorMsg in uploadImportImplicitlistResultView.uploadErrorMsgList">
              {{errorMsg}}<br/>
            </span>
          </template>
          <div v-if="!importedImplicit && uploadImportImplicitlistResultView">
            <b-table
              id="uploadImplicitPreview"
              striped
              border
              hover
              responsive
              sticky-header="500px"
              small
              :items="uploadImportImplicitlistResultView ? uploadImportImplicitlistResultView.uploadedList : []"
              :fields="uploadImplicitPreviewFields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              primary-key="_id"
              no-local-sorting
              no-provider-paging
              sort-icon-left
              class="mt-3"
            >
            <!-- Custom row above header -->
              <template v-slot:thead-top="data" lang="html">
                <b-tr>
                  <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Import</b-th>
                </b-tr>
              </template>
              <!--  rows  -->
              <template v-slot:cell(isChecked)="data" lang="html">
                <input v-if="data.item.status == 0 && data.item.isHeader" type="checkbox" v-model="data.item.isChecked" @change="editUploadedItem(data.item)"/>
                <i v-if="data.item.status == 0 && !data.item.isHeader" class="mdi mdi-check" style="display: block; color:green;"><!-- --></i>                
                <i v-if="data.item.status != 0" class="mdi mdi-window-close" style="display: block; color:red;"><!-- --></i>                
              </template>
              <template v-slot:cell(status)="data"  lang="html">
                <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
              </template>
              <template v-slot:cell(code)="data" lang="html">
                <span v-if="data.item.isHeader"><b>{{data.item.code}}</b></span>
                <span v-if="!data.item.isHeader">{{data.item.code}}</span>  
              </template>
              <template v-slot:cell(name)="data" lang="html">
                <span v-if="data.item.isHeader && data.item.status == 0"><b>{{data.item.name}}</b></span>
                <span v-if="data.item.isHeader && data.item.status != 0"><b>{{data.item.name}}</b> <span style="color:red;">THIS PACK WILL NOT BE IMPORTED</span></span> 
                <span v-if="!data.item.isHeader">{{data.item.name}}</span>  
              </template>
            </b-table>
          </div>
          <!-- RESULT TABLES IMPLICIT-->
          <div v-if="importedImplicit && uploadImportImplicitlistResultView && uploadImportImplicitlistResultView.importedList && uploadImportImplicitlistResultView.importedList.length > 0">
            <b-table
              id="uploadImplicitImported"
              striped
              border
              hover
              responsive
              sticky-header="500px"
              small
              :items="uploadImportImplicitlistResultView ? uploadImportImplicitlistResultView.importedList : []"
              :fields="uploadImplicitPreviewFields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              primary-key="_id"
              no-local-sorting
              no-provider-paging
              sort-icon-left
              class="mt-3"
            >
            <!-- Custom row above header -->
              <template v-slot:thead-top="data" lang="html">
                <b-tr>
                  <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Imported</b-th>
                </b-tr>
              </template>
              <!--  rows  -->
              <template v-slot:cell(isChecked)="data" lang="html">
                <i v-if="data.item.status == 0" class="mdi mdi-check" v-model="data.item.isChecked" style="display: block; color:green;"><!-- --></i>                
              </template>
              <template v-slot:cell(status)="data"  lang="html">
                <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
              </template>
              <template v-slot:cell(code)="data" lang="html">
                <span v-if="data.item.isHeader"><b>{{data.item.code}}</b></span>
                <span v-if="!data.item.isHeader">{{data.item.code}}</span>  
              </template>
              <template v-slot:cell(name)="data" lang="html">
                <span v-if="data.item.isHeader"><b>{{data.item.name}}</b></span>
                <span v-if="!data.item.isHeader">{{data.item.name}}</span>  
              </template>
            </b-table>
          </div>
          <div v-if="importedImplicit && uploadImportImplicitlistResultView && uploadImportImplicitlistResultView.notImportedList && uploadImportImplicitlistResultView.notImportedList.length > 0">
            <b-table
              id="uploadImplicitNotImported"
              striped
              border
              hover
              responsive
              sticky-header="500px"
              small
              :items="uploadImportImplicitlistResultView ? uploadImportImplicitlistResultView.notImportedList : []"
              :fields="uploadImplicitPreviewFields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              primary-key="_id"
              no-local-sorting
              no-provider-paging
              sort-icon-left
              class="mt-3"
            >
            <!-- Custom row above header -->
              <template v-slot:thead-top="data" lang="html">
                <b-tr>
                  <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Not Imported</b-th>
                </b-tr>
              </template>
              <!--  rows  -->
              <template v-slot:cell(isChecked)="data" lang="html">
                <span><!-- --></span>
              </template>
              <template v-slot:cell(status)="data"  lang="html">
                <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
              </template>
              <template v-slot:cell(code)="data" lang="html">
                <span v-if="data.item.isHeader"><b>{{data.item.code}}</b></span>
                <span v-if="!data.item.isHeader">{{data.item.code}}</span>  
              </template>
              <template v-slot:cell(name)="data" lang="html">
                <span v-if="data.item.isHeader"><b>{{data.item.name}}</b></span>
                <span v-if="!data.item.isHeader">{{data.item.name}}</span>  
              </template>
            </b-table>
          </div>
          <!-- RESULT TABLE -->
        </div>
      <template v-slot:modal-footer="{ cancel, ok }" lang="html">
        <fragment>
          <b-button variant="secondary" v-if=" filter.exportType === 'Commercial' ? !imported : !importedImplicit" @click="cancel">
            Cancel
          </b-button>
          <b-button variant="primary" v-if=" filter.exportType === 'Commercial' ? !uploadImportCommlistResultView && !imported : !uploadImportImplicitlistResultView && !importedImplicit" @click="filter.exportType === 'Commercial' ? uploadCommFile() : uploadImplicitFile()" :disabled="!fileName">
            Upload
          </b-button>
          <b-button v-if=" filter.exportType === 'Commercial' ? uploadImportCommlistResultView && !imported : uploadImportImplicitlistResultView && !importedImplicit" variant="secondary" @click="initializeUpload">
            Back
          </b-button>
          <b-button v-if=" filter.exportType === 'Commercial' ? uploadImportCommlistResultView && !imported : uploadImportImplicitlistResultView && !importedImplicit" variant="primary" @click="filter.exportType === 'Commercial' ? importCommList() : importImplicitList()">
            Proceed
          </b-button>
          <b-button variant="primary" v-if=" filter.exportType === 'Commercial' ? imported : importedImplicit" @click="ok">
            OK
          </b-button>
        </fragment>
      </template>
    </b-modal>
    <!-- Fine Modal import -->
  </section>
</template>

<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
const FileDownload = require('js-file-download');
export default {
  name: 'import_export_pack',
  props: ['model', 'previewData'],
  methods: {
    exportMarketing(){
      this.setSpinnerStatus(true)
      var params = {
        pCurrentModelVetele: this.model.value, 
        pModelFilter: this.filter.model, 
        pCurrentModelYearOnly: true,
        isPreview: this.isPreview,
        email: this.filter.email
      }
      this.axios
      .get('/ccb/auth/fe/packConf/exportMarketing' ,  {
        responseType: 'blob', params: params, ...this.authHeader})
        .then(response => {
        if(response.status == 200) {
          this.readFromBlob(response.data)
          .then(message => {                    
            this.$bvModal.msgBoxOk(message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true,
            })
          })
          .catch(error => {
            console.error('Errore durante la lettura del messaggio:', error);           
          });
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-export');
      })
    },
    exportMarketingTemplate(){
      this.setSpinnerStatus(true);
      this.axios
      .get('/ccb/auth/fe/packConf/exportMarketingTemplate' ,  {
        responseType: 'blob',
        params: {},
        ...this.authHeader}          
          )
        .then((response) => {
          this.setSpinnerStatus(false)
          var disposition = response.headers['content-disposition'];
          var filenameRegex = /fileName[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          var filename = matches[1].replace(/['"]/g, '');
          FileDownload(response.data, filename);
        }).finally(e=>{
          this.$bvModal.hide('modal-export');
        })
    },
    exportImplicitPack(){
      this.setSpinnerStatus(true);
      this.axios
      .get('/ccb/auth/fe/packConf/exportImplicitPacks' ,  {
        responseType: 'blob',
        params: { isPreview: this.isPreview },
        ...this.authHeader}          
          )
        .then((response) => {
          this.setSpinnerStatus(false)
          var disposition = response.headers['content-disposition'];
          var filenameRegex = /fileName[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          var filename = matches[1].replace(/['"]/g, '');
          FileDownload(response.data, filename);
        }).finally(e=>{
          this.$bvModal.hide('modal-export');
        })
    },
    exportStructuralPack(){
      this.setSpinnerStatus(true)
      var params = {
        pCurrentModelVetele: this.model.value, 
        pModelFilter: this.filter.model, 
        pCurrentModelYearOnly: true,
        isPreview: this.isPreview,
        email: this.filter.email
      }
      this.axios
      .get('/ccb/auth/fe/packConf/exportCommercialPacks' ,  {
        responseType: 'blob', params: params, ...this.authHeader})
        .then(response => {
        if(response.status == 200) {
          this.readFromBlob(response.data)
          .then(message => {                    
            this.$bvModal.msgBoxOk(message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true,
            })
          })
          .catch(error => {
            console.error('Errore durante la lettura del messaggio:', error);           
          });
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-export');
      })
    },
    initializeExport(){
      this.resetFilter()
    },
    initializeUpload(){
      this.uploadImportCommlistResultView = null
      this.uploadImportImplicitlistResultView = null
      this.fileName = ''
      this.imported = false
      this.importedImplicit = false
      this.editUploadList = []
      this.files = []
      this.resetFilter()
    },
    resetFilter(){
      this.filter = {
        model: 'MOD',
        exportType: 'Implicit',
        exportModel: 'Structural',
        email: null,
        destination: this.previewData ? 'preview' : 'final'
      }
    },
    importCommList(){
      this.setSpinnerStatus(true)
      let file=this.files[0]
      let bodyParams = {
        packConfEditedItemList : this.editUploadList
      }
      let formData = new FormData()
      formData.append("uploadFile", file)
      formData.append("importPackConfUtilJson",JSON.stringify(bodyParams))
      this.axios.post("/ccb/auth/fe/packConf/importCommercialPacks", formData , {
          params: { isPreview: this.isPreview },
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          ...this.authHeader}
        )
        .then((result) => {
          this.imported=true
          this.setSpinnerStatus(false)
          this.uploadImportCommlistResultView = result.data
          this.$emit('refresh');
      }).catch((err) => {
        this.setSpinnerStatus(false)
      });
    },
    importImplicitList(){
      this.setSpinnerStatus(true)
      let file=this.files[0]
      let bodyParams = {
        packConfEditedItemList : this.editUploadList
      }
      let formData = new FormData()
      formData.append("uploadFile", file)
      formData.append("importPackConfUtilJson",JSON.stringify(bodyParams))
      this.axios.post("/ccb/auth/fe/packConf/importImplicitPacks", formData , {
          params: { isPreview: this.isPreview },
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          ...this.authHeader}
        )
        .then((result) => {
          this.importedImplicit=true
          this.setSpinnerStatus(false)
          this.uploadImportImplicitlistResultView = result.data
          this.$emit('refresh');
      }).catch((err) => {
        this.setSpinnerStatus(false)
      });
    },
    uploadCommFile(){
      this.setSpinnerStatus(true)
      let file=this.files[0]
      let formData = new FormData()
      formData.append("uploadFile", file)
      this.axios.post("/ccb/auth/fe/packConf/uploadCommercialPacksFromExcel", formData , {
          //params: params,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          ...this.authHeader}
        )
        .then((result) => {
          this.setSpinnerStatus(false)
          this.imported = false
          this.editUploadList = []
          this.uploadImportCommlistResultView = result.data
      }).catch((err) => {
        this.setSpinnerStatus(false)
      });

    },
    uploadImplicitFile(){
      this.setSpinnerStatus(true)
      let file=this.files[0]
      let formData = new FormData()
      formData.append("uploadFile", file)
      this.axios.post("/ccb/auth/fe/packConf/uploadImplicitPacksFromExcel", formData , {
          //params: params,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          ...this.authHeader}
        )
        .then((result) => {
          this.setSpinnerStatus(false)
          this.importedImplicit = false
          this.editUploadList = []
          this.uploadImportImplicitlistResultView = result.data
      }).catch((err) => {
        this.setSpinnerStatus(false)
      });

    },
    changeFileName(){
      if(document.querySelector('#file-input').files[0] && document.querySelector('#file-input').files[0].name) {
        this.fileName = document.querySelector('#file-input').files[0].name;
        this.files = document.querySelector('#file-input').files;
      } else
      {
        this.fileName = '';
        this.files = [];
      }

    },
    changeFileNameImplicit(){
      if(document.querySelector('#file-input-implicit').files[0] && document.querySelector('#file-input-implicit').files[0].name) {
        this.fileName = document.querySelector('#file-input-implicit').files[0].name;
        this.files = document.querySelector('#file-input-implicit').files;
      } else
      {
        this.fileName = '';
        this.files = [];
      }

    },
    existsInListByParentCodeAndVet(list,item){
      let result = false
      return list.some(function(field) {
        if (item.parentCode === field.parentCode && item.vetList === field.vetList){
          return true
        } else {
          return false
        }
      });
    },
    editUploadedItem(item){
      if (!this.existsInListByParentCodeAndVet(this.editUploadList, item)) {
        this.editUploadList.push(item)
      } else {
        this.editUploadList.splice(this.editUploadList.indexOf(item), 1)
        this.editUploadList.push(item)
      }
    },
    readFromBlob(data){
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = function() {
          try {
            var jsonResponse = JSON.parse(reader.result);
            resolve(jsonResponse.message);
          } catch (error) {
            reject(error);
          }
        };
        reader.onerror = function() {
          reject(new Error('Errore durante la lettura del Blob'));
        };
        reader.readAsText(data);
      });
    },
    ...mapActions([
      'setSpinnerStatus'
    ]),
  },
  data () {
    return {
      sortBy:'code',
      sortDesc: false,
      exportTypeList: ['Commercial', 'Implicit'],
      exportModelList: ['Structural', 'Marketing', 'Marketing (template)'],
      filter: {
        model: 'MOD',
        exportType: 'Implicit',
        exportModel: 'Structural',
        email: null,
        destination: 'final'
      },
      uploadImplicitPreviewFields: [
        {
          key: 'isChecked',
          label: '',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'status',
          label: 'Details',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'code',
          label: 'Code',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'name',
          label: 'Name',
          thClass: 'newLine',
          visible: true,
          sortable: false
        }
      ], 
      uploadCommPreviewFields: [
        {
          key: 'isChecked',
          label: '',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'status',
          label: 'Details',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'model',
          label: 'Model',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'ver',
          label: 'Market',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'country',
          label: 'Country',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'parentCode',
          label: 'Parent Code',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'childCode',
          label: 'Child Code',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
         {
          key: 'inclExcl',
          label: 'Incl / Excl',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'optManovra',
          label: 'Opt manovra',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'alternateSet',
          label: 'Set',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'defaultSet',
          label: 'Default',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'compulsory',
          label: 'Compulsory',
          thClass: 'newLine',
          visible: true,
          sortable: false
        }
      ],
      uploadImportCommlistResultView:null,
      uploadImportImplicitlistResultView:null,
      editUploadList:[],
      imported:false,
      importedImplicit:false,
      fileName:'',
      files: [],
      fileLabel:"Choose File",
    }
  },
  computed: {
    isValidEmail(){
      // Espressione regolare per validare un indirizzo email
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      // Test della stringa con l'espressione regolare
      return emailRegex.test(this.filter.email);
    },
    isPreview(){
      return this.filter.destination === 'preview'
    },
    filterModelList(){
      return [{text: 'This model', value: 'MOD'}, {text: 'This family (' + `${this.model.rangeCode.charAt(0).toUpperCase()}${this.model.rangeCode.slice(1)}` + ' ' + this.model.my + ')', value: 'FAM'}];
    },
    ...mapGetters([
      'authHeader',
    ]) 
  }
}
</script>